import { IconButton } from '@mui/material';
import CONFIG from '../../../config';
import React from 'react';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import DocumentState from '../../client/dossier/DocumentState';
import axios from "axios";
import FicheGroupDocuments from './FicheGroupDocuments';


function FicheMetaGroupDocuments({ user, setUser, metaGroupIcon, metaGroupName, groupList, uploadable = false }) {
  return (
    <>
      {groupList.map((group) => (
        <FicheGroupDocuments key={group.groupName} user={user} setUser={setUser} groupIcon={group.groupIcon} groupName={group.groupName} documentList={group.documentsList} uploadable={uploadable}></FicheGroupDocuments>
      ))}
    </>
  );
}

export default FicheMetaGroupDocuments;